import { loadJq } from "@/lib/loadJq";
import { lazyLoad } from "@/lib/lazyLoad";


export interface CarouselResponsiveOptions {
  items: number,
}

/**
 * 配置
 */
export interface CarouselOptions {
  //是否延迟加载
  lazy: boolean,
  // 是否立即开始
  autoStart: boolean,
  //是否设置自动宽度
  autoWidth: boolean,
  //是否自动设置
  autoHeight: boolean,

  //自动滚动个数
  autoScrollNum?: number,
  wrap: 'circular' | 'first' | 'last' | 'both',
  // 每页偏移数量
  perPage: number,
  //自动滚动间隔时间
  interval: number,
  //不同宽度下显示效果
  responsive?: Record<string, CarouselResponsiveOptions | number>,
  //是否显示分页选项
  pagination: boolean,
  touch: boolean
};

type JCarouselOptions = Omit<CarouselOptions, 'responsive'> & {
  responsive?: Record<string, CarouselResponsiveOptions>
}

const defaultOptions: JCarouselOptions = {
  lazy: false,
  autoStart: false,
  autoWidth: true,
  autoHeight: false,
  interval: 5000,
  wrap: 'circular',
  perPage: 1,
  responsive: undefined,
  pagination: true,
  touch: true
};

const InitPagination = (j: JQuery, options: JCarouselOptions) => {


  const { autoStart, autoWidth, autoHeight, pagination, responsive } = options;
  const style = getComputedStyle(j.get(0)!)!
  const width = j!.innerWidth()! + parseInt(style.borderRightWidth!);
  const root = j.parent();

  let breakpointZone = 0;

  const setBreakpointZone = () => {
    if (responsive) {
      for (const key in responsive) {
        const bp = parseInt(key); // convert string to number
        if (width > bp) {
          breakpointZone = bp;
        }
      }
    }
  }

  let groupCells = options.perPage;
  if (responsive) {
    setBreakpointZone();
    groupCells = responsive[breakpointZone].items;
  }
  if (j.jcarousel('items').length <= groupCells) {
    root.addClass('is-hide-control');
  }



  root.find('.jcarousel-control-prev')
    .jcarouselControl({
      target: '-=' + groupCells
    });

  root.find('.jcarousel-control-next')
    .jcarouselControl({
      target: '+=' + groupCells
    });

  if (pagination) {

    root.find('.jcarousel-pagination')
      .on('jcarouselpagination:active', 'button', function () {
        //@ts-ignore
        $(this).addClass('active');
      })
      .on('jcarouselpagination:inactive', 'button', function () {
        //@ts-ignore
        $(this).removeClass('active');
      })
      .on('click', function (e) {
        e.preventDefault();
      })
      .jcarouselPagination({
        perPage: groupCells,
        item: function (page: any) {
          return '<button type="button" href="#' + page + '">' + page + '</button>';
        }
      });
  }


  // j.jcarousel('first').addClass('active');

  j.on('jcarousel:targetin', j.jcarousel('items').eq(0).prop('tagName'), function () {
    $(this).addClass('active');
  }).on('jcarousel:targetout', j.jcarousel('items').eq(0).prop('tagName'), function () {
    $(this).removeClass('active');
  });
  j.jcarousel('items').attr('style', '');
  if (autoWidth) {
    const itemWidth = width / groupCells;
    j.jcarousel('items').css('width', itemWidth + 'px');
  }
  //设置宽度
  if (autoHeight) {
    let maxheight = 0;
    j.jcarousel('items').each(function () {
      // @ts-ignore
      if ($(this)!.outerHeight() > maxheight) {
        // @ts-ignore // 忽略错误
        maxheight = $(this).outerHeight();
      }
    });
    j.jcarousel('items').css('height', maxheight + 'px');
  }


  if (autoStart && !root.hasClass('is-hide-control')) {
    j.jcarouselAutoscroll({
      interval: options.interval,
      autostart: autoStart,
      target: '+=' + (options.autoScrollNum ?? groupCells)
    });
  }
}
function getVisibleElementCount (container: HTMLElement) {
  const list = container.children[0]! as HTMLElement;

  const containerWidth = container.clientWidth;  // 获取div的宽度
  const child = list.children[0];  // 假设所有子元素宽度相同，获取第一个元素
  const childWidth = child.clientWidth;  // 获取子元素的宽度

  // console.log('getVisibleElementCount', containerWidth, childWidth)
  // 计算可见的元素数量
  const visibleCount = Math.floor(containerWidth / childWidth);

  return visibleCount;
}

const updateOptions = () => {

}

const InitPaginationCust = (carouselElement: HTMLElement, options: JCarouselOptions) => {
  loadJq(() => {
    import("jcarousel").then(() => {
      const $carousel = $(carouselElement);
      $carousel.on('jcarousel:reload jcarousel:createend', function () {
        InitPagination($carousel, options);
      });

      $carousel.jcarousel(options);


    })
    // if (options.touch && Browser.isSmall()) {
    if (options.touch && ("ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) {
      import("jquery-touchswipe").then(() => {
        $(carouselElement).swipe({
          swipeLeft: function () {
            $(this).parent().find('.jcarousel-control-next').trigger('click');
          },
          swipeRight: function () {
            $(this).parent().find('.jcarousel-control-prev').trigger('click');
          },
          threshold: 0,
          preventDefaultEvents: false
        });
      })
    }
  });
}


const getOption = () => {

}

const destroy = () => {

}

export const loadCarousel = (carouselElement: HTMLElement, options?: Partial<CarouselOptions>) => {

  // 合并配置时去掉 responsive 属性
  const { responsive, ...filteredOptions } = options || {};  // 通过解构赋值去掉 responsive

  // 合并配置
  const opt: JCarouselOptions = Object.assign({}, defaultOptions, filteredOptions);

  // 每次滚动显示个数
  const visibleCount = getVisibleElementCount(carouselElement);
  if (!opt.perPage) {
    opt.perPage = visibleCount;
  }

  if (responsive) {
    const responsiveTem: Record<string, CarouselResponsiveOptions> = {};
    for (const key in responsive) {
      const val = responsive[key];
      responsiveTem[key] = typeof val === 'number' ? { items: val } : val;
    }
    //@ts-ignore
    opt.responsive = responsiveTem;
  }

  if (opt.lazy) {
    lazyLoad([carouselElement], () => {
      InitPaginationCust(carouselElement, opt)
    });

  } else {
    InitPaginationCust(carouselElement, opt)
  }

}